<section class="newsletter-signup" [class.newsletter-signup--compact]="compact"
  [class.newsletter-signup--popup]="popup"
  [attr.aria-labelledby]="compact ? null : titleId">
  <div *ngIf="!compact" class="newsletter-copy">
    <span class="newsletter-eyebrow">{{ "BROCOM INDUSTRY · WIEDZA I OFERTY" | translate:"BROCOM INDUSTRY · WIEDZA I OFERTY" }}</span>
    <h2 [id]="titleId">{{ "NEWSLETTER" | translate:"NEWSLETTER" }}</h2>
    <p>{{ "Otrzymuj informacje branżowe, nowości produktowe i oferty dla subskrybentów." | translate:"Otrzymuj informacje branżowe, nowości produktowe i oferty dla subskrybentów." }}</p>
    <div *ngIf="reward?.enabled && reward?.discountPercentage" class="newsletter-reward">
      <span class="reward-spark" aria-hidden="true">%</span>
      <span><strong>{{ reward?.discountPercentage | number:'1.0-2' }}{{ '% zniżki' | translate }}</strong> {{ "na pierwsze opłacone zamówienie po zapisie." | translate:"na pierwsze opłacone zamówienie po zapisie." }}</span>
    </div>
  </div>

  <form [formGroup]="form" (ngSubmit)="submit()" class="newsletter-form" novalidate>
    <label class="newsletter-label" [for]="emailId">{{ "Służbowy adres e-mail" | translate:"Służbowy adres e-mail" }}</label>
    <div class="newsletter-input-row">
      <input [id]="emailId" type="email" formControlName="email" autocomplete="email"
        [placeholder]="'Adres e-mail' | translate:'Adres e-mail':'pl'"
        [attr.aria-invalid]="form.controls.email.invalid && form.controls.email.touched"
        [attr.aria-describedby]="form.controls.email.invalid && form.controls.email.touched ? emailErrorId : null">
      <button type="submit" [disabled]="isSubmitting">
        <span>{{ (isSubmitting ? 'Zapisywanie…' : (compact ? 'Zapisz się' : 'Dołącz do newslettera')) | translate }}</span>
      </button>
    </div>
    <p *ngIf="form.controls.email.invalid && form.controls.email.touched" [id]="emailErrorId"
      class="newsletter-validation">{{ "Wprowadź prawidłowy adres e-mail." | translate:"Wprowadź prawidłowy adres e-mail." }}</p>
    <label class="newsletter-consent">
      <input type="checkbox" formControlName="consent">
      <span>{{ "Zgadzam się otrzymywać informacje i oferty Brocom Industry. Mogę zrezygnować z subskrypcji w dowolnym momencie. Zobacz" | translate:"Zgadzam się otrzymywać informacje i oferty Brocom Industry. Mogę zrezygnować z subskrypcji w dowolnym momencie. Zobacz" }}
        <a routerLink="/legal/privacy-policy">{{ "Politykę prywatności" | translate:"Politykę prywatności" }}</a>.</span>
    </label>
    <p *ngIf="form.controls.consent.invalid && form.controls.consent.touched" class="newsletter-validation">
      {{ "Wyraź zgodę, aby zapisać się do newslettera." | translate:"Wyraź zgodę, aby zapisać się do newslettera." }}
    </p>
    <label class="newsletter-consent">
      <input type="checkbox" formControlName="termsAgreement" required aria-required="true">
      <span>{{ "Przeczytałem(-am) i akceptuję" | translate:"Przeczytałem(-am) i akceptuję" }}
        <a routerLink="/legal/terms-and-conditions" target="_blank" rel="noopener">{{ "Regulamin" | translate:"Regulamin" }}</a>
        {{ "oraz" | translate:"oraz" }}
        <a routerLink="/legal/privacy-policy" target="_blank" rel="noopener">{{ "Politykę prywatności" | translate:"Politykę prywatności" }}</a>.
      </span>
    </label>
    <p *ngIf="form.controls.termsAgreement.invalid && form.controls.termsAgreement.touched"
      class="newsletter-validation" role="alert">
      {{ "Zaakceptuj Regulamin i Politykę prywatności, aby zapisać się do newslettera." | translate:"Zaakceptuj Regulamin i Politykę prywatności, aby zapisać się do newslettera." }}
    </p>
    <p *ngIf="message" class="newsletter-message" [class.is-error]="isError" role="status">{{ message }}</p>
  </form>
</section>
